export const isEmpty = (v) => v === null || v === undefined || v === "";
export const removeEmptyValues = (m) => {
    return Object.entries(m).reduce((p, [k, v]) => (isEmpty(v) ? p : { ...p, [k]: v }), {});
};
function isErrorWithMessage(error) {
    return (typeof error === "object" &&
        error !== null &&
        "message" in error &&
        typeof error.message === "string");
}
function toErrorWithMessage(maybeError) {
    if (isErrorWithMessage(maybeError))
        return maybeError;
    try {
        return new Error(JSON.stringify(maybeError));
    }
    catch {
        // fallback in case there's an error stringifying the maybeError
        // like with circular references for example.
        return new Error(String(maybeError));
    }
}
export function getErrorMessage(error) {
    return toErrorWithMessage(error).message;
}
export function phoneNumberParser(props) {
    const { phoneNumber } = props;
    const strippedNumber = phoneNumber.startsWith("+1") ? phoneNumber.slice(2) : phoneNumber;
    const digitsOnly = strippedNumber.replace(/\D/g, "");
    return digitsOnly;
}
export function phoneNumberFormatter(props) {
    const { phoneNumber } = props;
    if (phoneNumber.length >= 11) {
        return { isFormatted: false, value: "" };
    }
    if (phoneNumber.length === 0) {
        return { isFormatted: true, value: "" };
    }
    else if (phoneNumber.length < 3) {
        return { isFormatted: true, value: `(${phoneNumber}` };
    }
    else if (phoneNumber.length === 3) {
        return { isFormatted: true, value: `(${phoneNumber})` };
    }
    else if (phoneNumber.length <= 6) {
        return { isFormatted: true, value: `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}` };
    }
    else {
        return {
            isFormatted: true,
            value: `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`,
        };
    }
}
// Mirrors subject data from the backend (suber.model.sub_req/subject-options)
// Translates DB value (key) into presentation layer (val) for GET req endpoints
// Any changes made here or in the backend must be updated
// in both places to keep things in sync.
export const subjectDataMap = {
    "General Education": "General Education",
    Elective: "Elective (Music, Art, etc.)",
    "English/Language Arts": "English/Language Arts",
    "Foreign Language": "World Language (Spanish, French, etc.)",
    "Health/P.E.": "Health/P.E.",
    "History/Social Studies": "History/Social Studies",
    Math: "Math",
    "Recess/Lunch": "Recess/Lunch",
    Science: "Science",
    SPED: "Special Education",
    "Study Hall/Homeroom": "Study Hall/Homeroom",
    Other: "Other",
    Unknown: "Unknown",
};
export function translateRequestSubjectData(params) {
    const { subjects } = params;
    const normalizeAndTranslate = (val) => {
        const trimmedVal = val.trim();
        return subjectDataMap[trimmedVal] ?? trimmedVal;
    };
    let translatedSubjects;
    if (Array.isArray(subjects)) {
        translatedSubjects = subjects.map(normalizeAndTranslate);
    }
    else if (typeof subjects === "string") {
        translatedSubjects = subjects.split(",").map(normalizeAndTranslate);
    }
    else {
        translatedSubjects = [];
    }
    return translatedSubjects;
}
export function shallowEqualArrays(a, b) {
    if (a.length !== b.length)
        return false;
    // Make a copy so we can mark matches
    const bUsed = new Array(b.length).fill(false);
    return a.every((itemA) => {
        // Find the first unused index in b that strictly equals itemA
        for (let i = 0; i < b.length; i++) {
            if (!bUsed[i] && itemA === b[i]) {
                bUsed[i] = true;
                return true;
            }
        }
        return false;
    });
}
//# sourceMappingURL=helpers.js.map